module.exports = __webpack_public_path__ + "src/img/selectIcon.7250aa9b.svg";